import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../_helpers';
import { IncidentEntity } from './entity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var IncidentService = /** @class */ (function (_super) {
    tslib_1.__extends(IncidentService, _super);
    function IncidentService(http) {
        var _this = _super.call(this, 'incidents', IncidentEntity) || this;
        _this.http = http;
        return _this;
    }
    IncidentService.ngInjectableDef = i0.defineInjectable({ factory: function IncidentService_Factory() { return new IncidentService(i0.inject(i1.HttpClient)); }, token: IncidentService, providedIn: "root" });
    return IncidentService;
}(BaseService));
export { IncidentService };
